import { render, staticRenderFns } from "./BackgroundSetter.vue?vue&type=template&id=5b0d1e33&scoped=true&"
import script from "./BackgroundSetter.vue?vue&type=script&lang=js&"
export * from "./BackgroundSetter.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundSetter.vue?vue&type=style&index=0&id=5b0d1e33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d1e33",
  null
  
)

component.options.__file = "BackgroundSetter.vue"
export default component.exports